var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 8.31252C1.50754 8.31054 2.13423 8.43366 2.719 8.67481C3.30378 8.91595 3.83509 9.27036 4.28236 9.71764C4.72964 10.1649 5.08405 10.6962 5.32519 11.281C5.56634 11.8658 5.68946 12.4925 5.68748 13.125",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 4.375C3.19564 4.375 5.42124 5.29687 7.06218 6.93782",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 0.875022C2.48397 0.871996 4.0776 1.18776 5.56385 1.80407C7.0501 2.42039 8.39953 3.32505 9.5342 4.4658",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 13.5625C1.79575 13.5625 2.1875 13.1707 2.1875 12.6875C2.1875 12.2043 1.79575 11.8125 1.3125 11.8125C0.829251 11.8125 0.4375 12.2043 0.4375 12.6875C0.4375 13.1707 0.829251 13.5625 1.3125 13.5625Z",
    fill: "#98A2B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7V13.125",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 10.0625H13.5625",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiplus);
export default __webpack_public_path__ + "static/media/wifiplus.01140de5ef336ac59940c6d4b7d5f1b5.svg";
export { ForwardRef as ReactComponent };